import React from 'react';

import './DocTitle.scss';

interface DocTitleProps {
    uid?: string;
    title: string;
    subtitle: string;
    className?: string;
}

export const DocTitle: React.FC<DocTitleProps> = ({uid, title, subtitle, className}) => (
        <div className={`doc-title ${className || ''}`}>
            <div className="doc-title__title">{title}</div>
            {uid && <div className="doc-title__uid">№&nbsp;{uid}</div>}
            <div className="doc-title__subtitle">{subtitle}</div>
        </div>
);
